module.exports = __webpack_public_path__ + "img/pnu_read_gallery4.8f57ebd2.jpg";